import type { AccessArea } from '@shared/types';

export const ALL_ACCESS_AREAS: AccessArea[] = [
  'task-management',
  'pj-kpi-management',
  'ricoh-spaces',
];

type AccessUser = { role: 'owner' | 'member' | 'disable'; accessAreas?: AccessArea[] } | null | undefined;

// UX gating helper for the client, consolidating the per-page fallbacks that had
// drifted apart (some omitted 'ricoh-spaces' for owners; only the Navbar denied
// the 'disable' role). One definition now, matching the server's semantics
// (backlog H7). Authoritative enforcement still lives server-side in
// api/src/lib/access.ts — this only decides what UI to show.
//   owner   -> every area
//   disable -> nothing
//   member  -> its explicit areas, defaulting to ['task-management']
export function resolveAccessAreas(user: AccessUser): AccessArea[] {
  if (!user || user.role === 'disable') return [];
  if (user.role === 'owner') return [...ALL_ACCESS_AREAS];
  return user.accessAreas ?? ['task-management'];
}

export function hasAccessArea(user: AccessUser, area: AccessArea): boolean {
  return resolveAccessAreas(user).includes(area);
}
